module.exports = __webpack_public_path__ + "static/media/building_2.d7f7a896.jpg";